/**************************************************
 * Nombre:       Home_Encontraras
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import circulo from "../../../Recursos/ic_circulo.svg";
import educativo from "../../../Recursos/sistema_educativo.png";
import historias from "../../../Recursos/historias.png";
import ic_educa from "../../../Recursos/ic_educativo.svg";
import ic_hisori from "../../../Recursos/ic_historias.svg";
import ic_galeria from "../../../Recursos/ic_galeria.svg";
import galeria from "../../../Recursos/galeria.png";
import ic_calendario from "../../../Recursos/ic_calendario.svg";
import calendario from "../../../Recursos/calendario.png";
import Tarjeta_Encontraras from "../../Tarjetas/Tarjeta_Encontraras";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Encontraras = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography
                                sx={{
                                    background: 'linear-gradient(91deg, #D5BAFB 0.48%, rgba(185, 150, 249, 0.00) 66.39%)',
                                    color: theme.palette.primary.main,
                                    px: 2,
                                    py: 1,
                                    borderRadius: 10
                                }}
                            >

                    <span>
                        <img src={circulo} width={20} height={'auto'}
                             style={{marginTop: 5, marginBottom: -5, marginRight: 10}}/>
                    </span>

                                Encontraras

                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 11, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={2}
                            >

                                {items.map((item, index) => (
                                    <Grid container size={{xs: 12, sm: 6, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Encontraras item={item}/>
                                    </Grid>
                                ))}


                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{
                justifyContent: 'center',
                backgroundColor: '#FFF',
                boxShadow: '0 4px 50px 0 rgba(133, 49, 253, 0.20)'
            }}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 3}}
                    spacing={2}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 11}}
                          sx={{justifyContent: 'flex-start', pb: sCell ? 6 : 0, pt: sCell ? 2 : 0}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            {items.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 6, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{p: 3, mb: sCell ? -4 : 0}}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography
                                                sx={{color: '#262626', fontWeight: 600}}
                                            >{item.subTitulo}</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: -1}}>
                                            <Typography
                                                sx={{color: '#545454', fontWeight: 400, fontSize: 12}}
                                            >{item.parrafo}</Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            ))}

                        </Grid>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Home_Encontraras

const items = [
    {
        icono: ic_educa,
        nombre: "Sistema Educativo",
        gradiente: 'linear-gradient(180deg, rgba(185, 150, 249, 0.00) 39.5%, #B996F9 100%)',
        descripcion: 'Un método de formación diseñado para que desarrolles habilidades empresariales reales, combinando teoría, práctica y experiencias que generan resultados tangibles.',
        img: educativo,
        subTitulo: 'Material de Apoyo',
        parrafo: 'Tendrás acceso a guías, recursos y herramientas que reforzarán cada aprendizaje y te ayudarán a aplicar de inmediato lo que aprendes.'
    },
    {
        icono: ic_hisori,
        largo: 20,
        nombre: "Historias de exito",
        gradiente: 'linear-gradient(180deg, rgba(124, 240, 255, 0.00) 39.5%, #7CF0FF 100%)',
        descripcion: 'Descubre los testimonios de personas que, gracias a su decisión y al acompañamiento del Team Tufiño, lograron transformar sus negocios y su vida.',
        img: historias,
        subTitulo: 'Comunidad Activa',
        parrafo: 'Un grupo de emprendedores que comparten, apoyan y celebran cada avance, porque crecer juntos es la base de nuestro éxito.'

    },
    {
        icono: ic_galeria,
        largo: 20,
        nombre: "Historias de exito",
        gradiente: 'linear-gradient(180deg, rgba(124, 240, 255, 0.00) 39.5%, #7CF0FF 100%)',
        descripcion: 'Revive en imágenes los momentos más inspiradores de nuestro camino: capacitaciones, eventos y logros que marcan un antes y un después',
        img: galeria,
        subTitulo: 'Expandiremos tu exito',
        parrafo: 'Cada experiencia dentro del Team Tufiño no solo te enseña, también amplía tus oportunidades y conecta tu visión con el éxito'
    },
    {
        icono: ic_calendario,
        largo: 20,
        nombre: "Galería de fotos",
        gradiente: 'linear-gradient(180deg, rgba(137, 138, 229, 0.00) 39.5%, #898AE5 100%)',
        descripcion: 'Aquí encontrarás todas las fechas clave para seguir aprendiendo, compartir con otros y hacer crecer tu proyecto empresarial.',
        img: calendario,
        subTitulo: 'No solo un expectador',
        parrafo: 'Aquí no vienes a mirar, vienes a participar, a vivir cada evento y a dar pasos firmes hacia tus metas.'
    },
]